import Vue from 'vue'
import VueBlurHash from 'vue-blurhash'
import 'vue-blurhash/dist/vue-blurhash.css'

Vue.use(VueBlurHash)
